<template>
  <div class="kr-layout-content">
    <!--个人基本资料-->
    <div class="publish">
      <div class="publish-top">
        <ul class="per-list">
          <li
            v-for="(item,index) in rout"
            :key="index"
            :class="{'active':n == index }"
            @click="trans(index,item.path)"
          >{{item.title}}</li>
        </ul>
        <ul class="total">
         <!-- <li>
            今日发布数量：
            <span>{{num}}</span> / 8
          </li> -->
          <li @click="open">发文规范</li>
        </ul>
      </div>
      <div class="norm-Tk" v-if="is_norm"  @touchmove.prevent>
          <div class="mask"></div>
          <div class="norm-cont">
              <p class="title">发文规范 <span class="iconfont icon-quxiao" @click="closeTk"></span></p>
              <p class="indent tex"> 档案号内容发文规范细则 标题、内容存在以下所述，该文章不符合发文规范，会被机器识别为低质内容，不予推荐：</p>
              <p class="tit">1.标题</p>
              <p class="indent"> 标题含错别字；标题字数过长（标题不得超过30个字）标题不完整、不通顺；标题含特殊符号；例如：★、㊣、~\(≧≦)/~等等；标题全部英文/外文、含繁体字；标题与内文无关，用词过于夸张，涉嫌标题党吸引流量；标题涉嫌恶俗；恶俗标题指含有辱骂性质的口头语，如他妈的（tm）、卧槽（我擦/我操/我艹）、傻逼（SB）、尼玛、二逼（EB）、日了狗、老子、劳资等。色情低俗／反动违法标题。</p>
              <p class="tit">2.正文</p>
               <p>（1）正文格式:全文繁体字、全文英文；全文大段乱码、未分段或无标点；内容不完整或重复（文字/图片）；文内特殊符号过多；</p>
              <p>（2）广告：文章含有营销购买信息，广告的对象为单一的某产品或品牌，包含文末广告信息；含有二维码、电话、个人微信、QQ号、微信群、QQ群等推广信息；推广微信公众号使用变体，包括但不限于：WX、微X，Wxin、威信、微~信~公~众~号等；发布内容含有购物链接、网盘资源下载链接等；于正文无关的其他推广。</p>
             <p>（3）低质、抄袭以图片为主体、图文夹杂的文章，3张以下（不含3张），内容不完整、不丰富；以文字为主体的文章，内容不完整/不丰富，一段内容/五行以下（不含五行）；全文内容以文字截图组成或者以一张长截图（图解内容除外）抄袭他人内容。</p>
             <p>（4）旧闻、虚假信息发布过时的信息，包括但不限于（法律法规、国际政策、体育赛事、活动、天气预报、节目预告等）；与档案号平台已有内容重复。</p>
             <p>(5) 内容违反现行政策与法律法规，违反宪法基本原则的内容；危害国家安全、泄露国家机密，颠覆国家政权、破坏国家统一、损害国家荣誉和利益的内容；破坏国家宗教政策，宣扬邪教和封建迷信的内容；煽动民族仇恨、破坏民族团结内容；散布谣言、扰乱社会秩序、破坏社会稳定的内容；散布恐怖、色情、暴力、赌博或教唆犯罪的内容；侮辱或诽谤他人，侵害他人合法权益的内容；不符合社会主义核心价值观的内容。</p>
             <div class="btn" @click="closeTk">确定</div>
          </div>
      </div>
      <div class="per-info">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { setInterval } from "timers";
export default {
  data() {
    return {
      n: this.$route.query.n || 0,
      num: 0,
      is_norm:false,
      rout: [
		{
		  title: "一键发布",
		  path: "/publishLianjie"
		},
        {
          title: "发布文章",
          path: "/publishArticle"
        },
        {
          title: "发布动态",
          path: "/publishDynamic"
        },
        {
          title: "发布视频",
          path: "/publishVideo"
        },
        // {
        //   title: "发布工作",
        //   path: "/publishInvite"
        // }
      ]
    };
  },
  mounted() {
    this.getRule();
    if (this.n == 0) {
      // this.$router.push("/publishArticle");
      this.$router.push("/publishLianjie");
    }
    this.getPublishSum();
  },
  methods: {
    trans(i, path) {
      this.n = i;
      this.$router.push(path);
    },
    getPublishSum() {
      this.$http
        .get("/api/media/015-getPublishSum", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            this.num = res.data.rows[0];
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getRule() {
      // 获取发文规范
      this.$http
        .get("/api/001-dicList", {
          params: {
            keyWrod: "PostCode"
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            this.ruleContent = res.data.rows[0].content;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    open() {
      // this.$alert(this.ruleContent, "发文规范", {
      //   confirmButtonText: "确定",
      //   callback: action => {}
      // });
       var mo=function(e){e.preventDefault();};
        document.body.style.overflow='hidden';
        document.addEventListener("touchmove",mo,false);//禁止页面滑动
      this.is_norm = true;
    },
    closeTk(){
       var mo=function(e){e.preventDefault();};
        document.body.style.overflow='';//出现滚动条
        document.removeEventListener("touchmove",mo,false);
       this.is_norm = false;
    }
  }
};
</script>

<style scoped>
.per-info {
  padding-left: 0px;
}
.publish .publish-top .total {
  width: auto;
}
.publish .publish-top .total li {
	height: unset;
	line-height: 48px;
	margin-top: unset;
	padding: 0 10px;
}
.publish .publish-top .total li:last-child {
	border-left: none;
}
.norm-Tk{width:100%;height:100%;position:relative;}
.norm-cont{width:600px;height:700px;background: #fff;position: fixed;top:50%;left:50%;border-radius: 4px;
z-index:999;transform: translate(-50%,-50%);padding:0px 16px;}
.norm-cont .title{width:100%;height:50px;line-height: 50px;font-size:16px;}
.norm-cont .title span{float:right;font-size: 18px;margin-top:12px;}
.norm-cont .indent{text-indent:28px }
.norm-cont p{line-height: 24px;}
.norm-cont .tit{font-size: 15px;}
.norm-cont .btn{float:right;border:1px solid #2E8043;color:#2E8043;padding:3px 10px;font-size: 14px;}
</style>